import * as yup from "yup";
import React from "react";

import {
  BRAND_NAME,
  DELIVERY_INTERVALS,
  WEEKDAY,
  BRAND_PATHS,
  language,
} from "@chef/constants";
import { formatTimeInterval, isMealboxBasketType } from "@chef/helpers";
import { isAddonProduct, isStandaloneProduct } from "@chef/helpers";
import {
  Swap,
  Delivery,
  User,
  Card,
  Discount,
  Support,
  Chat,
} from "@chef/icons/large";
import {
  CalendarQuery,
  showNotification,
  TimeblocksQuery,
} from "@chef/state-management";

// TODO: fill inn
export const SHARED_BRAND = (
  {
    AMK: {
      MY_ACCOUNT_TITLE: "Min konto",
      MY_ACCOUNT_HREF: BRAND_PATHS.MY_ACCOUNT_HREF,
      LINKS: [
        {
          title: "Mitt abonnement",
          href: BRAND_PATHS.MY_SUBSCRIPTION_LINK,
          page: "subscription",
          Icon: Swap,
        },
        {
          title: "Leveringsinformasjon",
          href: BRAND_PATHS.DELIVERY_INFORMATION_PAGE,
          page: "deliveryInformation",
          Icon: Delivery,
        },
        {
          title: "Personalia",
          href: BRAND_PATHS.PERSONAL_INFORMATION_PAGE,
          page: "accountInformation",
          Icon: User,
        },
        {
          title: "Betalingsoversikt",
          href: BRAND_PATHS.PAYMENT_LINK,
          page: "paymentMethod",
          Icon: Card,
        },
        {
          title: "Rabattkoder og gavekort",
          href: BRAND_PATHS.MY_DISCOUNTS_PAGE,
          page: "discountsAndGiftcards",
          Icon: () =>
            React.createElement(Discount, {
              className: "w-10 h-10 fill-black text-white",
            }),
        },
        {
          title: "Kontakt oss",
          href: BRAND_PATHS.CONTACT_US_PAGE,
          page: "contactUs",
          Icon: Support,
        },
        {
          title: "Kontaktreservasjon",
          href: BRAND_PATHS.CONTACT_SETTINGS_PAGE,
          page: "contactSettings",
          Icon: Chat,
        },
      ],

      WEEKDAYS: {
        0: "Søndager",
        1: "Mandager",
        2: "Tirsdager",
        3: "Onsdager",
        4: "Torsdager",
        5: "Fredager",
        6: "Lørdager",
      },
      DELIVERY_FREQUENCIES: {
        10: "Hver uke",
        20: "Partallsuker",
        30: "Oddetallsuker",
      },
    },
    GL: {
      MY_ACCOUNT_TITLE: "Min konto",
      MY_ACCOUNT_HREF: BRAND_PATHS.MY_ACCOUNT_HREF,
      LINKS: [
        {
          title: "Mitt abonnement",
          href: BRAND_PATHS.MY_SUBSCRIPTION_LINK,
          page: "subscription",
          Icon: Swap,
        },
        {
          title: "Leveringsinformasjon",
          href: BRAND_PATHS.DELIVERY_INFORMATION_PAGE,
          page: "deliveryInformation",
          Icon: Delivery,
        },
        {
          title: "Personalia",
          href: BRAND_PATHS.PERSONAL_INFORMATION_PAGE,
          page: "accountInformation",
          Icon: User,
        },
        {
          title: "Betalingsoversikt",
          href: BRAND_PATHS.PAYMENT_LINK,
          page: "paymentMethod",
          Icon: Card,
        },
        {
          title: "Rabattkoder og gavekort",
          href: BRAND_PATHS.MY_DISCOUNTS_PAGE,
          page: "discountsAndGiftcards",
          Icon: () =>
            React.createElement(Discount, {
              className: "w-10 h-10 fill-black text-white",
            }),
        },
        {
          title: "Kontakt oss",
          href: BRAND_PATHS.CONTACT_US_PAGE,
          page: "contactUs",
          Icon: Support,
        },
        {
          title: "Kontaktreservasjon",
          href: BRAND_PATHS.CONTACT_SETTINGS_PAGE,
          page: "contactSettings",
          Icon: Chat,
        },
      ],

      WEEKDAYS: {
        0: "Søndager",
        1: "Mandager",
        2: "Tirsdager",
        3: "Onsdager",
        4: "Torsdager",
        5: "Fredager",
        6: "Lørdager",
      },
      DELIVERY_FREQUENCIES: {
        10: "Hver uke",
        20: "Partallsuker",
        30: "Oddetallsuker",
      },
    },

    LMK: {
      MY_ACCOUNT_TITLE: "Mitt konto",
      MY_ACCOUNT_HREF: BRAND_PATHS.MY_ACCOUNT_HREF,
      LINKS: [
        {
          title: "Min prenumeration",
          href: BRAND_PATHS.MY_SUBSCRIPTION_LINK,
          page: "subscription",
          Icon: Swap,
        },
        {
          title: "Leveransuppgifter",
          href: BRAND_PATHS.DELIVERY_INFORMATION_PAGE,
          page: "deliveryInformation",
          Icon: Delivery,
        },
        {
          title: "Mina uppgifter",
          href: BRAND_PATHS.PERSONAL_INFORMATION_PAGE,
          page: "accountInformation",
          Icon: User,
        },
        {
          title: "Betalningsöversikt",
          href: BRAND_PATHS.PAYMENT_LINK,
          page: "paymentMethod",
          Icon: Card,
        },
        {
          title: "Rabattkoder & presentkort",
          href: BRAND_PATHS.MY_DISCOUNTS_PAGE,
          page: "discountsAndGiftcards",
          Icon: () =>
            React.createElement(Discount, {
              className: "w-10 h-10 fill-black text-white",
            }),
        },
        {
          title: "Kontakta oss",
          href: BRAND_PATHS.CONTACT_US_PAGE,
          page: "contactUs",
          Icon: Support,
        },
        {
          title: "Kontaktinställningar",
          href: BRAND_PATHS.CONTACT_SETTINGS_PAGE,
          page: "contactSettings",
          Icon: Chat,
        },
      ],

      WEEKDAYS: {
        0: "Söndagar",
        1: "Måndagar",
        2: "Tisdagar",
        3: "Onsdagar",
        4: "Torsdagar",
        5: "Fredagar",
        6: "Lördagar",
      },
      DELIVERY_FREQUENCIES: {
        10: "Varje vecka",
        20: "Jämna veckor",
        30: "Udda veckor",
      },
    },

    RN: {
      MY_ACCOUNT_TITLE: "Min konto",
      MY_ACCOUNT_HREF: BRAND_PATHS.MY_ACCOUNT_HREF,
      LINKS: [
        {
          title: "Mit abonnement",
          href: BRAND_PATHS.MY_SUBSCRIPTION_LINK,
          page: "subscription",
          Icon: Swap,
        },
        {
          title: "Leveringsoplysninger",
          href: BRAND_PATHS.DELIVERY_INFORMATION_PAGE,
          page: "deliveryInformation",
          Icon: Delivery,
        },
        {
          title: "Kontooplysninger",
          href: BRAND_PATHS.PERSONAL_INFORMATION_PAGE,
          page: "accountInformation",
          Icon: User,
        },
        // {
        //   title: "Personlig information",
        //   href: "/app/min-konto/personlig-information",
        //   page: "personalInformation",
        //   Icon: User,
        // },
        {
          title: "Betalingsmetode",
          href: BRAND_PATHS.PAYMENT_LINK,
          page: "paymentMethod",
          Icon: Card,
        },
        {
          title: "Rabatkoder og gavekort",
          href: BRAND_PATHS.MY_DISCOUNTS_PAGE,
          page: "discountsAndGiftcards",
          Icon: () =>
            React.createElement(Discount, {
              className: "w-10 h-10 fill-black text-white",
            }),
        },
        {
          title: "Kontakt os",
          href: BRAND_PATHS.CONTACT_US_PAGE,
          page: "contactUs",
          Icon: Support,
        },
        {
          title: "Kontaktindstillinger",
          href: BRAND_PATHS.CONTACT_SETTINGS_PAGE,
          page: "contactSettings",
          Icon: Chat,
        },
      ],

      WEEKDAYS: {
        0: "Søndag",
        1: "Mandag",
        2: "Tirsdag",
        3: "Onsdag",
        4: "Torsdag",
        5: "Fredag",
        6: "Lørdag",
      },

      DELIVERY_FREQUENCIES: {
        10: "Hver uge",
        20: "Lige ugenumre",
        30: "Ulige ugenumre",
      },
    },
  } as const
)[BRAND_NAME];

export type PAGE = typeof SHARED_BRAND["LINKS"][number]["page"];
export type LINK = typeof SHARED_BRAND["LINKS"][number];

export const isMyAccountSubscriptionProduct = ({
  productTypeId,
}: {
  productTypeId: string;
}) =>
  isAddonProduct({ productTypeId }) || isStandaloneProduct({ productTypeId });

export const createDeliveryTimeslotOptions = (
  timeblocks: TimeblocksQuery["timeblocksData"]["timeblocks"],
) => {
  const mod = (n: number, m: number) => ((n % m) + m) % m;

  return [...timeblocks]
    .sort((a, b) => mod(a.weekday + 1, 7) - mod(b.weekday + 1, 7)) // Sort by weekday, Saturday -> Friday
    .map((timeblock) => {
      const weekDay = SHARED_BRAND.WEEKDAYS[timeblock.weekday as WEEKDAY];

      return {
        label: `${weekDay}, ${formatTimeInterval(
          timeblock.from,
          timeblock.to,
          "m",
          "-",
        )}`,
        value: timeblock.timeblockId,
      };
    });
};

export const createDeliveryFrequencyOptions = () => {
  return [
    DELIVERY_INTERVALS.EVERY_WEEK,
    DELIVERY_INTERVALS.EVEN_WEEKS,
    DELIVERY_INTERVALS.ODD_WEEKS,
  ].map((frequency) => {
    return {
      label: SHARED_BRAND.DELIVERY_FREQUENCIES[frequency],
      value: frequency,
    };
  });
};

export const findFirstContinuouslyPausedCalendarWeeks = (
  calendar?: CalendarQuery["calendar"],
) => {
  if (!calendar) {
    return undefined;
  }

  const startIndex = calendar.findIndex(
    (calendarWeek) =>
      calendarWeek.baskets.find(isMealboxBasketType)?.shippingDetails
        .hasDelivery === false,
  );

  if (startIndex === -1) {
    return [];
  }

  let endIndex = startIndex;

  for (let i = startIndex + 1; i < calendar.length; i++) {
    if (
      calendar[i].baskets.find(isMealboxBasketType)?.shippingDetails
        .hasDelivery === true
    ) {
      endIndex = i;
      break;
    }
  }

  return calendar.slice(startIndex, endIndex);
};

export const sendSuccessNotification = (message: string) =>
  showNotification({
    type: "success",
    message,
    autoClose: 15000,
  });

export const sendErrorNotification = (message: string) =>
  showNotification({
    type: "error",
    message,
    autoClose: 15000,
  });

interface shareReferralCodeViaFacebookProps {
  method: "share" | "send";
  href?: string;
  link?: string;
  description?: string;
  FB: any;
}

export const shareReferralCodeViaFacebook = ({
  method,
  href,
  link,
  description,
  FB,
}: shareReferralCodeViaFacebookProps) => {
  FB.ui({
    method,
    href,
    link,
    description,
  });
};

const intl = (
  {
    no: {
      INVITATION_SHARED: "Invitasjon delt!",
      SHARE_ON_FACEBOOK_ERROR:
        "Oops! Kunne ikke dele rabattkoden på Facebook Messenger, vennligst forsøk igjen senere!",
      PHONE_NUMBER_DIGITS: 8,
      PHONE_NUMBER_ERROR: "Skriv et gyldig mobilnummer",
      PHONE_REQUIRED: "Telefonnummer er påkrevd",
      CAN_ONLY_CONTAIN_NUMBERS: "Kan bare inneholde tall",
      DAYS: "dager",
    },
    se: {
      INVITATION_SHARED: "Inbjudan delad!",
      SHARE_ON_FACEBOOK_ERROR:
        "Det gick inte att dela rabattkoden på Facebook Messenger, försök igen senare!",
      PHONE_NUMBER_DIGITS: 10,
      PHONE_NUMBER_ERROR: "Ange ett giltigt mobilnummer",
      PHONE_REQUIRED: "Telefonnummer krävs",
      CAN_ONLY_CONTAIN_NUMBERS: "Kan bara innehålla siffror",
      DAYS: "dagar",
    },
    dk: {
      INVITATION_SHARED: "Anbefaling sendt!",
      SHARE_ON_FACEBOOK_ERROR:
        "Oops! Kunne ikke dele rabatkoden på Facebook Messenger, venligst prøv igen senere!",
      PHONE_NUMBER_DIGITS: 8,
      PHONE_NUMBER_ERROR: "Indtast et gyldigt mobilnummer",
      PHONE_REQUIRED: "Telefonnummer er påkrævet",
      CAN_ONLY_CONTAIN_NUMBERS: "Kan kun indeholde tal",
      DAYS: "dage",
    },
  } as const
)[language];

export const telephoneSchema = yup
  .object({
    telephone: yup
      .string()
      .matches(/^[0-9]*$/, intl.CAN_ONLY_CONTAIN_NUMBERS)
      .length(intl.PHONE_NUMBER_DIGITS, intl.PHONE_NUMBER_ERROR)
      .required(intl.PHONE_REQUIRED),
  })
  .required();

export const getDateAfterNDays = ({
  inputDate,
  daysToAdd,
}: {
  inputDate: Date | string;
  daysToAdd: number;
}) => {
  const date = new Date(inputDate);
  date.setDate(date.getDate() + daysToAdd);
  return date.toISOString();
};

export const getTimeLeftUntilEndDate = ({ endDate }: { endDate: string }) => {
  const now = new Date();
  const diffMilliseconds =
    Date.parse(endDate.toString()) - Date.parse(now.toString());

  const minutesInADay = 60 * 24;

  const minutesLeft = Math.floor(diffMilliseconds / 1000 / 60);
  const hoursLeft = Math.floor(minutesLeft / 60);
  const daysLeft = Math.floor(minutesLeft / minutesInADay);

  let formattedTimeLeft;

  if (minutesLeft >= minutesInADay * 2) {
    formattedTimeLeft = `${daysLeft} ${intl.DAYS}`;
  } else if (minutesLeft >= 60) {
    formattedTimeLeft = `${hoursLeft}h`;
  } else {
    formattedTimeLeft = `${minutesLeft}m`;
  }

  return {
    formattedTimeLeft: diffMilliseconds > 0 ? formattedTimeLeft : "",
  };
};

export const getProgressAsPercentage = ({
  current,
  target,
}: {
  current: number;
  target: number;
}): number => {
  if (current > target) {
    return 100;
  }
  const progress = (current / target) * 100;

  if (isNaN(progress)) {
    return 0;
  }

  return progress;
};
